import { useRef, useEffect } from 'react';

const useUnloadTab = (isBeforeUnloadEnabled: boolean, fn?: () => void) => {
  const cb = useRef(fn); // init with fn, so that type checkers won't assume that current might be undefined

  useEffect(() => {
    cb.current = fn;
  }, [fn]);

  useEffect(() => {
    const onUnload = e => {
      cb.current?.();
      (e ?? window.event).preventDefault();
      (e ?? window.event).returnValue = ''; //Gecko + IE
      return ''; //Webkit, Safari, Chrome
    };

    if (isBeforeUnloadEnabled) {
      window.addEventListener('beforeunload', onUnload);
    } else {
      window.removeEventListener('beforeunload', onUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', onUnload);
    };
  }, [isBeforeUnloadEnabled]);
};

export default useUnloadTab;
